import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "./store";

const dateTimeFormats = {
  ENG: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
  },
  KOR: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
  },
};

// const numberFormats = {
//   ENG: {
//     currency: {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     },
//     currency3: {
//       minimumFractionDigits: 3,
//       maximumFractionDigits: 3,
//     },
//     currency4: {
//       minimumFractionDigits: 4,
//       maximumFractionDigits: 4,
//     },
//     currency5: {
//       minimumFractionDigits: 5,
//       maximumFractionDigits: 5,
//     },
//     number: {
//       maximumFractionDigits: 0,
//     },
//   },
// };

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return Object.freeze(messages);
}

export default new VueI18n({
  locale: store.state.lang || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "ENG",
  messages: loadLocaleMessages(),
  dateTimeFormats: dateTimeFormats,
});
